import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { SharedModule } from '../shared.module';
import { BackBtnComponent } from './components/back-btn/back-btn.component';
import { LoadingBtnComponent } from './components/loading-btn/loading-btn.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { MediaUrlPipe } from './pipes/media-url.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@NgModule({
	imports: [
		NgxDatatableModule,
		SharedModule,
		ReactiveFormsModule,
		TooltipModule.forRoot(),
		BsDropdownModule.forRoot(),
		ModalModule.forRoot(),
		NgSelectModule,
		PopoverModule.forRoot(),
		NzLayoutModule,
		NzGridModule,
		NzCardModule,
		NzAvatarModule,
		NzInputNumberModule,
		NzTypographyModule,
		NzIconModule,
		NzDatePickerModule,
		NzSelectModule,
		NzToolTipModule,
	],
	providers: [MediaUrlPipe],
	declarations: [
		LoginPageComponent,
		BackBtnComponent,
		MediaUrlPipe,
		TruncatePipe,
		LoadingBtnComponent,
	],
	exports: [
		MediaUrlPipe,
		TruncatePipe,
		BackBtnComponent,
		LoadingBtnComponent,
		LoginPageComponent,
	],
})
export class SharedPagesModule {}
